import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Api from "../../helpers/Api"; // Adjust the import path as necessary
import AppLayout from '../../components/layout/AppLayout';
import SubHeader from '../../components/subheader/SubHeader';
import CommonTable from '../components/table/CommonTable';
import styled from "styled-components";
import LoadingPage from "../loading/LoadingPage";
import AppTheme from '../../themes/AppTheme';
import NotFound from '../components/Notfound/NotFound';
import NotFoundIcon from '../../images/not-found.svg';

export const Container = styled.div`
  border-radius: 5px;
  border: 1px solid ${AppTheme.header.colors.tableBorder};
  background: ${AppTheme.header.colors.whiteColor};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);
  float: left;
  width: 100%;
  padding: 0;
`;

const ListSchools = () => {
    const [schools, setSchools] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const schoolColumns = [
        {key: 'name', label: 'Name'},
        {key: 'createdAt', label: 'Created At', type: 'datetime'},
        {key: 'updatedAt', label: 'Updated At', type: 'datetime'},
    ];

    useEffect(() => {
        fetchSchools();
    }, []);

    const fetchSchools = async () => {
        setLoading(true);
        try {
            const data = await Api.listSchools();
            setSchools(data);
            setError('');
        } catch (err) {
            setError('Failed to fetch schools. Please try again later.');
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (id) => {
        await Api.deleteSchool(id);
        fetchSchools();
    };

    const handleEdit = (id) => {
        navigate(`/schools/${id}`);
    };

    const handleViewUsers = (id) => {
        navigate(`/schools/${id}/users`);
    };

    if (loading) return <LoadingPage/>
    if (error) return <div>Error: {error}</div>;

    return (
        <AppLayout>
            <Container>
                <SubHeader
                    heading='Schools'
                    description={'View Credential Issuance Across Schools'}
                    href={'/schools/create'}
                    label={'Add New School'}
                />

                {/* Table component */}
                {schools.length > 0 ? (
                    <CommonTable
                        columns={schoolColumns}
                        data={schools}
                        getActionsConfig={(item) => {
                            return {
                                edit: true,
                                delete: true,
                            }
                        }}
                        onDelete={handleDelete}
                        onEdit={handleEdit}
                    />
                ) : (
                    <NotFound
                        icon={NotFoundIcon}
                        message={'Looks like you have no school  yet'}
                    />
                )}
            </Container>
        </AppLayout>
    );
};

export default ListSchools;
